import React from "react";
import { Link } from "react-scroll";

export const NavbarList = ({ sectionName }) => {
  return (
    <li className="capitalize">
      <Link to={sectionName} smooth={true} duration={500}>
        {sectionName}
      </Link>
    </li>
  );
};
